import { useCallback } from 'react'

import { useAppSelector } from '@/store/hook'
import {
  selectAddressScheme,
  selectFormattedRegions,
  selectRegions,
} from '@/store/selectors/configSelector'
import { ADDRESS_SCHEME_TYPES } from '@/libs/constants/configs'
import { getAddress } from '@/libs/utils/addressUtils'

const useRegion = () => {
  const regions = useAppSelector(selectRegions)
  const addressScheme = useAppSelector(selectAddressScheme)
  const isUSAAddressScheme = addressScheme === ADDRESS_SCHEME_TYPES.USA
  const formattedRegions = useAppSelector(selectFormattedRegions)

  const isStandardScheme = addressScheme === ADDRESS_SCHEME_TYPES.STANDARD
  const isShowRegion = !isStandardScheme && formattedRegions.length > 0

  const getAddressWithRegion = useCallback(
    (data, ignores = [], separator) => {
      const effectiveIgnores = isStandardScheme ? [...ignores, 'region'] : ignores
      return getAddress(data, regions, effectiveIgnores, separator, isUSAAddressScheme)
    },
    [regions, isUSAAddressScheme, isStandardScheme],
  )

  return {
    regions: formattedRegions,
    isShowRegion,
    getAddressWithRegion,
  }
}

export default useRegion
